import { templateStore } from '../template/index.js';

/**
 * Render recipe list into a container
 */
export function displayRecipes(container, recipes = []) {
	if (!container) return;

	const itemTemplate = templateStore.get('recipe/item.ejs');
	const emptyTemplate = templateStore.get('recipe/empty.ejs');
	const listTemplate = templateStore.get('recipe/list.ejs');

	if (!recipes.length) {
		// eslint-disable-next-line no-undef
		container.innerHTML = ejs.render(emptyTemplate);
		return;
	}

	// eslint-disable-next-line no-undef
	const itemsHtml = recipes.map(recipe => ejs.render(itemTemplate, { recipe })).join('');

	// eslint-disable-next-line no-undef
	container.innerHTML = ejs.render(listTemplate, { itemsHtml });
}

/**
 * Render loading state
 */
export function renderLoading(container) {
	if (!container) return;
	container.innerHTML = `
        <div class="flex items-center flex-col text-sm text-gray-900 gap-2 font-medium justify-center p-6 w-full h-full min-h-[100px]">
            <div class="w-8 h-8 border-3 border-primary-100 border-t-primary-500 rounded-full animate-spin"></div>
            ${wpcore.direct_t({ en: 'Loading recipes...', fr: 'Chargement des recettes...' })}
        </div>
    `;
}
